// extracted by mini-css-extract-plugin
var _1 = "ActivityItem-module__activityAvatars--H6fVC";
var _2 = "ActivityItem-module__activityFirstRow--cBBoM";
var _3 = "ActivityItem-module__activityIcon--MgpUA";
var _4 = "ActivityItem-module__activityInner--vpYrX";
var _5 = "ActivityItem-module__activityItem--J9v8F";
var _6 = "ActivityItem-module__activityLinkArrow--Q8vZo";
var _7 = "ActivityItem-module__activityNames--_k4xF";
var _8 = "ActivityItem-module__activitySecondRow--dp14f";
var _9 = "ActivityItem-module__activitySeparatorIcon--fLGr1";
var _a = "ActivityItem-module__activitySeparatorText--fJ4fr";
var _b = "ActivityItem-module__activityTime--NyYtA";
var _c = "ActivityItem-module__activityVerticalLine--phZbf";
var _d = "ActivityItem-module__actorName--JauFQ";
var _e = "ActivityItem-module__animateUploadProgressBarWidth--i8gZB";
var _f = "ActivityItem-module__animatedBackground--RZVSd";
var _10 = "ActivityItem-module__component--HXz1w";
var _11 = "ActivityItem-module__hoverIndicator--kD94E";
var _12 = "ActivityItem-module__isInteractive--TtuYe";
export { _1 as "activityAvatars", _2 as "activityFirstRow", _3 as "activityIcon", _4 as "activityInner", _5 as "activityItem", _6 as "activityLinkArrow", _7 as "activityNames", _8 as "activitySecondRow", _9 as "activitySeparatorIcon", _a as "activitySeparatorText", _b as "activityTime", _c as "activityVerticalLine", _d as "actorName", _e as "animateUploadProgressBarWidth", _f as "animatedBackground", _10 as "component", _11 as "hoverIndicator", _12 as "isInteractive" }
